import {ChangeDetectionStrategy, Component, computed, inject, Signal, signal, WritableSignal} from "@angular/core";
import {Page} from "../../navigation/page";
import {OrderModel} from '../../order/order.model';
import {OrderingContextModel} from '../../ordering-context/ordering-context.model';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {TipSelectionPanelComponent} from "../tip-selection-panel/tip-selection-panel.component";
import {CurrencyPipe} from '../../utils/currency.pipe';
import {ButtonComponent} from '../../buttons/button/button.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';
import {OrderingPhase, SessionModel} from '../../session/session.model';

@Component({
    selector: "woa-tip-selection-page",
    templateUrl: "./tip-selection-page.component.html",
    styleUrl: "./tip-selection-page.component.scss",
    providers: [{provide: Page, useExisting: TipSelectionPageComponent}],
    imports: [
        ButtonComponent,
        CurrencyPipe,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        TipSelectionPanelComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TipSelectionPageComponent extends Page {
    public sessionModel: SessionModel = inject(SessionModel);
    public orderModel: OrderModel = inject(OrderModel);
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);

    OrderingPhase = OrderingPhase;

    public readonly tipAmount: WritableSignal<number> = signal<number>(this.orderModel.tipAmount());
    public readonly tipSelected: WritableSignal<boolean> = signal<boolean>(false);

    public readonly title: Signal<string> = computed(() =>
        this.orderingContextModel.currentStore().tipInstructions ? "woa.message.tip.instructions" : "woa.message.tip.default");
    public readonly instructionParams: Signal<Record<string, string | number>> = computed<Record<string, string | number>>(() =>
        ({instructions: this.orderingContextModel.currentStore().tipInstructions}));

    async applyTip(confirmed: boolean): Promise<void> {
        if (this.sessionModel.orderingPhase() === OrderingPhase.PAYMENT && !confirmed) {
            return;
        }
        this.orderModel.tipAmount.set(this.tipAmount());
        this.orderingContextModel.tipSelected.set(this.tipSelected());
        void this.dismiss(true);
    }
}
